import { Separator } from 'app/components/ui/Separator'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import React from 'react'
import styled, { useTheme } from 'styled-components'

import { MswDevToolsForm } from './MswDevToolsForm'

type Props = {
  onPanelClose: () => void
}
export const MswDevToolsPanel = ({ onPanelClose }: Props): JSX.Element => {
  const theme = useTheme()

  return (
    <Panel>
      <PanelHeader>
        <Title size={4}>Mock DevTools</Title>
        <ButtonClose onClick={onPanelClose}>
          <svg
            width='20'
            height='20'
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M18.1814 16L31.7569 29.5756L29.5751 31.7574L15.9995 18.1819L2.42401 31.7574L0.242188 29.5756L13.8177 16L0.242188 2.42449L2.42401 0.242676L15.9995 13.8182L29.5751 0.242676L31.7569 2.42449L18.1814 16Z'
              fill='#0E1A2F'
            />
          </svg>
        </ButtonClose>
      </PanelHeader>
      <Separator></Separator>
      <HelpText
        variant='s16'
        mt={1.5}
        mb={3}
        color={theme.color.primari.grigioEstra}
      >
        Tramite questo form è possibile impostare quali dati saranno resituiti
        dalle API mock, così da poter visualizzare e testare ogni pagina nelle
        varie situazioni.
      </HelpText>
      <FormWrapper>
        <MswDevToolsForm />
      </FormWrapper>
    </Panel>
  )
}

const Panel = styled.div`
  position: fixed;
  z-index: 99999;
  bottom: 0px;
  width: 100%;
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow.espansa};
  border-radius: 10px;
  padding: 2rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    right: 0px;
    width: 500px;
    margin-right: 2rem;
    margin-bottom: 2rem;
  }
`

const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 1rem;
`

const ButtonClose = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
`

const HelpText = styled(Text)`
  text-align: center;
`

const FormWrapper = styled.div`
  margin-top: 2rem;
`
